var map = {
	"./amazon_ses.svg": 9557,
	"./google.svg": 1922,
	"./outlook.svg": 2345,
	"./sendgrid.svg": 1026,
	"./sendinblue.svg": 5398,
	"./smtp.svg": 7687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7973;